import React, {FC, Fragment} from "react";
import {Outlet} from "react-router-dom";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {footerLinks} from "data/constants/navigation";
import {Header} from "views/components/header/header/header.component";
import {Footer} from "views/components/footer/footer.component";
import {ITippingLayoutController} from "./tipping_layout.controller";
import {ReactComponent as LogoIcon} from "assets/img/nrlTipping.svg";

export const TippingLayout: FC = observer(() => {
	const {subNavItems, burgerNavItems} = useViewController<ITippingLayoutController>(
		Bindings.TippingLayoutController
	);

	return (
		<Fragment>
			<Header LogoIcon={LogoIcon} subNavItems={subNavItems} burgerNavItems={burgerNavItems} />
			<Outlet />
			<Footer links={footerLinks} />
		</Fragment>
	);
});
